(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ModelEquationDialogController', ModelEquationDialogController);

    ModelEquationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ModelEquation', 'Model'];

    function ModelEquationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ModelEquation, Model) {
        var vm = this;

        vm.modelEquation = entity;
        vm.clear = clear;
        vm.save = save;
        vm.models = Model.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.modelEquation.id !== null) {
                ModelEquation.update(vm.modelEquation, onSaveSuccess, onSaveError);
            } else {
                ModelEquation.save(vm.modelEquation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('portalApp:modelEquationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
